// import core components
import parser from "html-react-parser";

// import custom components
import Button from "@/elements/Shared/Button";
import WhiteSquare from "@/elements/Shared/DesignComponents/WhiteSquare";

// import style
import styles from "./worktogether.module.scss";

// import interfaces
import WorkTogetherProps from "@/interfaces/WorkTogether";

function WorkTogether({
  title = "Travaillons<br>ensemble!",
  content = "Vous recherchez une agence Web qui <strong>s'engage à fond dans votre développement?</strong> Faites-nous part de votre projet et nous bâtirons des solutions à la mesure de vos ambitions.",
  buttonText = "Décrivez-nous votre projet",
  isDesignVisible = true,
  designStyle = {
    position: "top-right",
    isAlternative: false,
    isLighter: false,
    isHidden: false,
  },
  isAlternativeTitleMaxWidth = false,
}: WorkTogetherProps) {
  return (
    <section className={`degrade ${styles._bg_default}`}>
      <div className={`container ${styles._container}`}>
        <h2
          className={`${styles._title} ${
            isAlternativeTitleMaxWidth ? styles._alternative : ""
          }`}
        >
          {parser(title)}
        </h2>
        <div>
          <p className={styles._text}>{parser(content)}</p>
          <Button
            path="/contact"
            bg={"white"}
            color={"purple"}
            border={false}
            icon={true}
          >
            {buttonText}
          </Button>
        </div>
      </div>
      {isDesignVisible && (
        <WhiteSquare
          isVisibleOnMobile={false}
          isAlternative={designStyle.isAlternative}
          isLighter={designStyle.isLighter}
          isHidden={designStyle.isHidden}
          position={designStyle.position}
        />
      )}
    </section>
  );
}

export default WorkTogether;
